import { createIcon } from "@chakra-ui/icons";

const Zap = createIcon({
  displayName: "Zap",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M13 2L4.09344 12.6879C3.74463 13.1064 3.57023 13.3157 3.56756 13.4925C3.56524 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2467 10.1111C20.1092 10 19.8368 10 19.292 10H12L13 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="PqIb"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default Zap;
